export const validateInputs = (inputs) => {
  let oldPasswordValid = false;
  let passwordValid = false;
  let passwordConfirmValid = false;
  if (inputs["oldPassword"] !== undefined) {
    oldPasswordValid = validatePassword(inputs.oldPassword);
  }
  if (inputs["password"] !== undefined) {
    passwordValid = validatePassword(inputs.password);
  }
  if (inputs["passwordConfirm"] !== undefined)
    passwordConfirmValid = validatePasswordConfirm(
      inputs.password,
      inputs.passwordConfirm,
    );

  return { oldPasswordValid, passwordValid, passwordConfirmValid };
};

export const validatePassword = (password) => password.length >= 8;

export const validatePasswordConfirm = (password, passwordConfirm) =>
  password === passwordConfirm;
